import { render, staticRenderFns } from "./VSwiper.vue?vue&type=template&id=548e0c07&"
import script from "./VSwiper.vue?vue&type=script&lang=js&"
export * from "./VSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports